<button
  [type]="type()"
  [disabled]="disabled()"
  [class]="buttonClasses()"
  (click)="handleClick($event)"
>
  @if (leadingIcon()) {
    <i [class]="leadingIcon()"></i>
  }
  <span class="v2-btn__content"><ng-content /></span>
</button>
